// extracted by mini-css-extract-plugin
export var bundleBuilderPage = "BDP-module--bundle-builder-page--2e633";